import http from '@services/http'
import { ISendVoc, IVocInfo, IAttendVoc, IAttendVocAnswer } from '@protocol/voc'

export default {
  getVocInfo(data: IVocInfo.Params): Promise<IVocInfo.Schema> {
    return http.post('voc/info', data || {})
  },

  sendAnswer(data: ISendVoc.Params): Promise<ISendVoc.Schema> {
    return http.post('voc/sendAnswer', data || {})
  },

  attendVoc(data:IAttendVoc.Params): Promise<IAttendVoc.Schema> {
    return http.post('voc/attendVoc', data || {})
  },

  attendVocAnswer(data: IAttendVocAnswer.Params): Promise<IAttendVocAnswer.Schema> {
    return http.post('voc/attendVocAnswer', data || {})
  }

}
